import { Form, Formik } from "formik";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import { userid } from "../../Common/Credentials.js";
import Footer from "../../Component/Footer.js";
import Header from "../../Component/Header.js";
import Menu from "../../Component/Menu.js";
import { FormikTextField } from "../../CommonComponents/FormField.js";
import { Spinner } from "react-bootstrap";
import { Autocomplete } from "@mui/material";
import MasterService from "../MasterService.js";
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TextfieldComponent from "../../Component/TextfieldComponent.jsx";
import AutoCompeteField from "../../NewUI/NewComponents/AutoCompeteField.jsx";

class AddState extends Component {
  constructor(props) {
    super(props);
    this.state = {
      state: "",
      message: "",
      loader: false,
      countriesList: [],
      country: "",
      countryid: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.validate = this.validate.bind(this);
  }

  onSubmit(values) {
    this.setState({ loader: true });
    let data = {
      name: this.state.state.toUpperCase(),
      country: this.state.countryid
    };
    MasterService.AddState(data)
      .then(() => this.props.navigate("/states"))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
        this.setState({ message: e.response.data.message, loader: false });
      });
  }

  handleCountryChange = (value, values) => {
    if (value !== undefined || value !== "") {
      this.setState({ country: values.name, countryid: values.id });
    }
  };

  componentDidMount() {
    if (userid === undefined) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      this.props.navigate(`/`);
    }

    MasterService.getCountries().then(res => this.setState({ countriesList: res.data, loading: false }))
      .catch((e) => {
        if (e.response.data.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          this.props.navigate(`/`);
        }
      })
  }

  validate(values) {
    let errors = {};

    if (!values.state || values.state === "") {
      errors.state = "State is Required";
    }
    return errors;
  }

  render() {
    let { id, state, countriesList, country, countryid } = this.state;

    return (
      <div>
        <Header />
        <Menu />
        <div className="content-wrapper">
        <div className="UI-container">
            <div className="UI-header">
          <Breadcrumb breadcrumbs={[{name:"Home",path:"/superadminmasters"},{name:"States",path:"/states"},{name:"Add State",path:null}]}/>
          </div>
            <div className="UI-form-card">
              <Formik
                initialValues={{ id, state, countriesList, country, countryid }}
                onSubmit={this.onSubmit}
                validateOnChange={false}
                validate={this.validate}
                enableReinitialize={true}
              >
                {({errors}) => (
                  <Form autoComplete="off">
                    <div className="form-row">
                      <fieldset className="col-md-3">
                        <AutoCompeteField label={"Country"} name={"country"} id="country" options={countriesList} value={this.state.country} onChange={this.handleCountryChange} labelKey={"name"} valueKey={"name"} error={errors?.country} required/>
                      </fieldset>
                      <fieldset className="form-group col-md-3">
                        <TextfieldComponent
                          className="form-control"
                          type="text"
                          name="state"
                          label="Enter State"
                          onChange={(e) =>this.setState({state: e.target.value,message: "",})}
                          error={errors?.state}
                          required
                        />
                      </fieldset>
                    </div>
                    <div className="form-group col-md-12 text-red">
                      {this.state.message}
                    </div>
                    {this.state.loader === true ? (
                      <button className="UI-btn UI-btn-primary" disabled>
                        <Spinner animation="border" size="sm" />
                        &nbsp;{"Saving"}
                      </button>
                    ) : (
                      <button
                        className="UI-btn UI-btn-primary"
                        type="submit"
                      >
                        Save
                      </button>
                    )}
                    <Link
                      as="button"
                      className="UI-btn UI-btn-outline ml-1"
                      to={{ pathname: "/states" }}
                    >Cancel
                    </Link>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    );
  }
}
export default withRouter(AddState);
